import renderRootElement from '@rover/utilities/renderRootElement';

import GuaranteePageContainer from './GuaranteePageContainer';

renderRootElement(GuaranteePageContainer, '#react-guarantee-page');
if (module.hot) {
  module.hot.accept('./GuaranteePageContainer', () => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    renderRootElement(require('./GuaranteePageContainer').default, '#react-guarantee-page');
  });
}
